import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logout, setToken } from "../slices/auth/auth.slice";
import { RootState } from "../store";
import { LoginResponse } from "./auth-api/types";

/**
 *
 * @param baseUrl
 * @returns wrapper around the fetch wich inculdes bunch of additional things
 */

export const createBaseService = (baseUrl: string) =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const newHeaders = headers ?? new Headers();

      newHeaders.set("X-Tenant-ID", `${process.env.REACT_APP_TENANT_ID}`);

      const token = (getState() as RootState).auth.token;

      if (token) {
        newHeaders.set("authorization", `Bearer ${token}`);
      }

      return newHeaders;
    },
  });

export const createBaseServiceWithInterceptor =
  (
    baseUrl: string
  ): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> =>
  async (args, api, extraOptions) => {
    const baseQuery = createBaseService(baseUrl);

    let result = await baseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
      const refreshToken = (api.getState() as RootState).auth.refreshToken;

      const refreshResult = await baseQuery(
        {
          url: `/refresh?refreshToken=${refreshToken}`,
          method: "POST",
        },
        api,
        extraOptions
      );

      if (refreshResult.data) {
        api.dispatch(setToken(refreshResult.data as LoginResponse));

        result = await baseQuery(args, api, extraOptions);
      } else {
        api.dispatch(logout());
      }
    }
    return result;
  };
